enum FormState {
  IN_PROGRESS = 'in-progress',
  WAITING_RESULT = 'waiting-result',
  DONE = 'done'
}

export default FormState;
